import { suporte } from '../api/client';

/**
 * Aviso de que o ambiente está sendo operado por alguém de fora da organização
 * (`superadminvisual` §3).
 *
 * Aparece no topo do painel do CLIENTE, acima da topbar. Desde que o acesso
 * deixou de ser somente leitura, ele é a ÚNICA coisa que diferencia esta sessão
 * de uma sessão normal do cliente — as telas são as mesmas e os botões todos
 * funcionam. Por isso não é discreto, e por isso o texto fala de escrita.
 */
export function BannerSuporte() {
  const sessao = suporte.atual();
  if (!sessao) return null;

  function encerrar() {
    suporte.sair();
    // Recarga completa em vez de navegação do router: garante que o cache do
    // React Query com dados do cliente não sobreviva à volta para a plataforma.
    window.location.href = '/master';
  }

  return (
    <div className="impersonation-banner">
      <i className="ti ti-eye" />
      <span>
        Você está dentro de <strong>{sessao.organizationName}</strong>. Alterações valem no
        ambiente do cliente e ficam <strong>registradas em seu nome</strong>.
      </span>
      <button type="button" className="btn btn-secondary btn-sm" onClick={encerrar}>
        <i className="ti ti-arrow-back-up" /> Encerrar acesso
      </button>
    </div>
  );
}
